<template>
  <div id="app">
    <MainView />
    <MobileHelper v-if="isMobileDevice" />
  </div>
</template>

<script>
// Vue framework imports
import { useHead } from '@vueuse/head';

// Local imports with new directory structure
import MainView from './components/layout/MainView.vue';
import MobileHelper from './components/common/MobileHelper.vue';
import { generateMetaInfo } from './utils/seo';
import { logCurrentHeadTags, checkSEOImplementation } from './utils/seo';

export default {
  name: 'App',
  components: {
    MainView,
    MobileHelper
  },
  data() {
    return {
      isMobileDevice: false
    };
  },
  setup() {
    // Set up default head metadata
    useHead(generateMetaInfo());
    
    return {};
  },
  mounted() {
    // Detect if current device is mobile
    this.detectMobileDevice();
    window.addEventListener('resize', this.detectMobileDevice);
    
    // Test SEO implementation (will output to console)
    setTimeout(() => {
      console.log('Testing SEO implementation...');
      logCurrentHeadTags();
      checkSEOImplementation();
    }, 2000); // Wait for all components to mount
  },
  methods: {
    detectMobileDevice() {
      // Check if viewport width is <= 768px
      this.isMobileDevice = window.innerWidth <= 768;
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.detectMobileDevice);
  }
}
</script>

<style>
#app {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  max-width: 100vw;
  background-color: var(--smoky-black);
}

/* Ensure body also has no unintended margins */
body, html {
  padding: 0;
  margin: 0;
  background-color: var(--smoky-black);
  /* Enable native mobile scrolling */
  -webkit-overflow-scrolling: touch;
  /* Prevent zoom on double tap */
  touch-action: manipulation;
}

/* Global styles or App-specific styles can be placed here */
html {
  scroll-behavior: smooth;
}
</style>
